export default __webpack_public_path__ + "static/media/syringe-icon.df506d79.png";